(function () {
  const sticky = document.querySelector('[data-egdc-pdp-sticky]');
  const sentinel = document.querySelector('[data-egdc-pdp-sentinel]');
  if (!sticky || !sentinel || !('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    },
    { rootMargin: '0px 0px -100% 0px', threshold: 0 }
  );

  observer.observe(sentinel);

  // Wire the sticky CTA to trigger the real product-form submit so this is
  // a true add-to-cart, not a scroll affordance. Falling through to the
  // form's own submit handler keeps Dawn's variant-required validation
  // and error UI intact.
  const ctaButton = sticky.querySelector('[data-egdc-sticky-atc]');
  if (!ctaButton) return;

  ctaButton.addEventListener('click', function () {
    const sectionId = sticky.dataset.sectionId;
    const submitButton = sectionId
      ? document.getElementById('ProductSubmitButton-' + sectionId)
      : document.querySelector('product-form button[type="submit"]');
    if (submitButton) {
      submitButton.click();
    }
  });
})();
